/* ============================================================
   CUTE CALCULUS — YOUR LINKS
   ------------------------------------------------------------
   This file holds the actual links to your files, and NOTHING
   else. It is the one file that is yours. No update I ever send
   you will touch it, so pasting a new cc-catalog.js can never
   wipe your links again.

   HOW TO ADD A LINK
     1. Shopify admin, Content, Files.
     2. Upload the PDF if it is not already there.
     3. Click the little link icon beside it to copy its link.
     4. Find the matching line below and paste between the quotes.
     5. Save. That is it.

   A line left as '' means that item shows as "coming soon" on
   the site, which is safe. Nothing 404s.

   A link here always wins over whatever is in cc-catalog.js, so
   you only ever have to look in one place.

   ONE RULE WORTH KNOWING: an id may appear only ONCE in this
   file. If it appears twice, the LOWER one silently wins and the
   upper one does nothing. That had happened to algebra1-guide.
   ============================================================ */

window.CC_LINKS = {

  /* ---------- FREE FILES, live ---------- */
  'algebra1-guide':      'https://cdn.shopify.com/s/files/1/0816/4530/6049/files/Cute_Calculus_-_Algebra_1_Cheat_Sheet_NEW_730f6fc1-f867-43a4-b3f2-30ff13ad8bd4.pdf?v=1789410935',
  'geometry-sheet':      'https://cdn.shopify.com/s/files/1/0816/4530/6049/files/Cute_Calculus_-_Geometry_Cheat_Sheet.pdf?v=1789410935',
  'algebra2-sheet':      'https://cdn.shopify.com/s/files/1/0816/4530/6049/files/Cute_Calculus_-_Algebra_2_Cheat_Sheet.pdf?v=1789410935',
  'precalc-sheet':       'https://cdn.shopify.com/s/files/1/0816/4530/6049/files/Cute_Calculus_-_Precalculus_Cheat_Sheet.pdf?v=1789410935',
  'calculus-sheet':      'https://cdn.shopify.com/s/files/1/0816/4530/6049/files/Cute_Calculus_-_Calculus_Cheat_Sheet.pdf?v=1789410935',

  'six-alg1':            'https://cdn.shopify.com/s/files/1/0816/4530/6049/files/Cute_Calculus_-_Algebra_1_Six_Weeks_Review.pdf?v=1789336806',
  'six-alg2':            'https://cdn.shopify.com/s/files/1/0816/4530/6049/files/Cute_Calculus_-_Algebra_2_Six_Weeks_Review.pdf?v=1789336806',
  'six-geo':             'https://cdn.shopify.com/s/files/1/0816/4530/6049/files/Cute_Calculus_-_Geometry_Six_Weeks_Review.pdf?v=1789336806',
  'six-precalc':         'https://cdn.shopify.com/s/files/1/0816/4530/6049/files/Cute_Calculus_-_Precalculus_Six_Weeks_Review.pdf?v=1789336806',
  'six-calc':            'https://cdn.shopify.com/s/files/1/0816/4530/6049/files/Cute_Calculus_-_Calculus_Six_Weeks_Review.pdf?v=1789336806',

  'functions-packet':    'https://cdn.shopify.com/s/files/1/0816/4530/6049/files/Cute_Calculus_-_Functions_Practice.pdf?v=1789395522',
  'parent-functions':    'https://cdn.shopify.com/s/files/1/0816/4530/6049/files/Cute_Calculus_-_Parent_Functions.pdf?v=1789659839',
  'trig-identities':     'https://cdn.shopify.com/s/files/1/0816/4530/6049/files/Trig_Identities_Reference.pdf?v=1789659341',
  'spot-the-identity':   'https://cdn.shopify.com/s/files/1/0816/4530/6049/files/Spot_the_Trig_Identity_Practice.pdf?v=1789659342',
  'tsia2-book':          'https://cdn.shopify.com/s/files/1/0816/4530/6049/files/Pass_the_TSIA2_Math_-_Practice_Book.pdf?v=1789526678',

  /* ---------- FREE FILES, still to upload ----------
     Upload the PDF under Content, Files, then paste its link here. */
  'six-prealg':          'https://cdn.shopify.com/s/files/1/0816/4530/6049/files/PreAlgebra-First-Six-Weeks-Review.pdf?v=1789939071',   /* Pre-Algebra, first six weeks review */
  'apchem-unit1':        'https://cdn.shopify.com/s/files/1/0816/4530/6049/files/AP-Chemistry-Unit-1-Packet.pdf?v=1789939148',   /* AP Chemistry Unit 1, from zero */
  'apchem-sigfigs':      'https://cdn.shopify.com/s/files/1/0816/4530/6049/files/Cute_Calculus_-_AP_Chemistry_Significant_Figures.pdf?v=1789939182',   /* AP Chemistry Significant Figures */
  'ivt-packet':          'https://cdn.shopify.com/s/files/1/0816/4530/6049/files/Intermediate-Value-Theorem-Packet.pdf?v=1789939223',   /* Intermediate Value Theorem packet */
  'precalc-start':       'https://cdn.shopify.com/s/files/1/0816/4530/6049/files/Cute_Calculus_-_Precalculus_Six_Weeks_Review_52f43d15-d59a-4cf7-8e0d-53cac8b43dbe.pdf?v=1789939940',   /* Precalculus, the first three weeks */
  'precalc-placement':   'https://cdn.shopify.com/s/files/1/0816/4530/6049/files/Precalculus_Ready_Workbook_CuteCalculus.pdf?v=1789939389',   /* Ready for AP Precalculus */

  /* ---------- PAID ITEMS ----------
     These need a PRODUCT or LISTING page, not a file. A file link on a
     paid item hands the buyer the PDF for free, which is what two of
     these were doing. Both are parked below with their old file links
     kept in a comment, so nothing is lost. Paste the product page link
     in and the card goes live as a paid item. */
  'desmos-guide':        '',   /* Pretty Smart Desmos. Parked file link: https://cdn.shopify.com/s/files/1/0816/4530/6049/files/Pretty_Smart_Desmos_How_To_-_PRINTABLE_f640e9a0-caa8-4a6b-9c6c-0bd92733acfe.pdf?v=1789398806 */
  'algebra1-booklet':    '',   /* Algebra 1, The Whole Year. Parked file link: https://cdn.shopify.com/s/files/1/0816/4530/6049/files/Cute_Calculus_-_Algebra_1_The_Whole_Year.pdf?v=1789395522 */
  'psv-etsy':            '',   /* Pretty Smart vocab, print at home */
  'final-precalc':       '',   /* AP Precalculus Final Exam Prep */
  'before-ap-chem':      '',   /* Before AP Chem workbook */

  /* ---------- the homeschool bundles ---------- */
  'homeschool-k':        '',   /* Homeschool Math, Kindergarten */
  'homeschool-1':        '',   /* Homeschool Math, Grade 1 */
  'homeschool-2':        '',   /* Homeschool Math, Grade 2 */

  /* ---------- the Rest of the Year Pass ----------
     All ten of these are the SAME product. Paste the one product link
     into all ten lines and ten cards go live at once. */
  'six2-alg1':           '',
  'six2-alg2':           '',
  'six2-geo':            '',
  'six2-precalc':        '',
  'six2-calc':           '',
  'six3-prealg':         '',
  'six3-alg1':           '',
  'six3-alg2':           '',
  'six3-geo':            '',
  'six3-precalc':        '',
  'six3-calc':           '',

  /* ---------- Fact Family Friends, Amazon links ---------- */
  'fff-1':               '',   /* Book One */
  'fff-2':               '',   /* Book Two */
  'fff-3':               '',   /* Book Three */

  /* ---------- cover pictures are NOT links, they go in the
     catalog's img field, not here ---------- */

};

/* If the catalog finished loading first, apply these now. If it has not
   loaded yet, it will call this itself the moment it does. Either order
   works, and running it twice changes nothing. */
if (window.CC_CATALOG && window.CC_CATALOG.applyLinks) window.CC_CATALOG.applyLinks();